<template>
  <div style="width: 100% ;padding: 10px">
    <div style="margin: 10px 0">
      <div style="margin: 10px 0">
        <el-tooltip content="支持模糊搜索，不区分大小写" placement="top" effect="light">
          <el-input v-model="search" placeholder="请输入型号/图纸号/厂商/工件总数" style="width:35%"></el-input>
        </el-tooltip>
        <el-button type="primary" style="margin-left:5px" @click = "getTableDataShow">查询</el-button>
        <el-button type="primary" @click="remove">重置</el-button>
        <el-button type="primary" @click="sortDialogVisible = true">排序设置</el-button>
        <el-button type="primary">
          <div title="确定要清除缓存并刷新吗？这可能需要一些时间" @click="clean">清除缓存刷新
          </div>
        </el-button>
      </div>
    </div>
    <el-dialog title="排序设置" :visible.sync="sortDialogVisible" width="560px">
      <div v-for="(rule, index) in sortRules" :key="index" class="sort-rule-row">
        <el-select v-model="rule.prop" placeholder="排序字段" style="width: 200px" @change="getTableDataShow">
          <el-option
              v-for="option in sortOptions"
              :key="option.prop"
              :label="option.label"
              :value="option.prop"
              :disabled="isSortOptionDisabled(option.prop, index)">
          </el-option>
        </el-select>
        <el-select v-model="rule.order" placeholder="排序方式" style="width: 120px" @change="getTableDataShow">
          <el-option label="升序" value="ascending"></el-option>
          <el-option label="降序" value="descending"></el-option>
        </el-select>
        <el-button icon="el-icon-top" :disabled="index === 0" @click="moveSortRule(index, -1)"></el-button>
        <el-button icon="el-icon-bottom" :disabled="index === sortRules.length - 1" @click="moveSortRule(index, 1)"></el-button>
        <el-button type="danger" icon="el-icon-delete" @click="removeSortRule(index)"></el-button>
      </div>
      <div v-if="sortRules.length === 0" class="sort-empty">暂未设置排序规则</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearSortRules">清空排序</el-button>
        <el-button type="primary" @click="addSortRule">添加排序</el-button>
        <el-button @click="sortDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-table
        :data="tableDataShow"
        :default-sort="{prop: 'sendtime', order: 'descending'}"
        @sort-change="handleSortChange"
        style="width: 95%">
      <el-table-column
          prop="xinghao"
          label="型号"
          sortable="custom"
          width="150">
      </el-table-column>
      <el-table-column
          prop="totalNum"
          label="工件总数"
          sortable="custom"
          width="70">
      </el-table-column>
      <el-table-column
          prop="feijainNum"
          label="废件数"
          sortable="custom"
          width="70">
        <template slot-scope="scope">
          <el-button
              type="text"
              size="small"
              @click = "errorId = scope.row.id,errorShow = true">
            {{scope.row.feijainNum}}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
          prop="zhuangtai"
          label="状态"
          v-if="false"
          width="70">
      </el-table-column>
      <el-table-column
          label="进度"
          width="700">
        <template slot-scope="scope">
          <progress-bar-gropu v-if="upLode" :progresses="scope.row.gongxuList" :gongjian-id="scope.row.id"/>
<!--          <div style="width: 580px" v-if='scope.row.status == "success"'><el-progress :text-inside="true" :stroke-width="24" :percentage="scope.row.pre" status="success"></el-progress></div>-->
<!--          <div style="width: 580px" v-if='scope.row.status == "exception"'><el-progress :text-inside="true" :stroke-width="24" :percentage="scope.row.pre" status="exception"></el-progress></div>-->
<!--          <div style="width: 580px" v-if='scope.row.status == "warning"'><el-progress :text-inside="true" :stroke-width="24" :percentage="scope.row.pre" status="warning"></el-progress></div>-->
<!--          <div style="width: 580px" v-if='scope.row.status != "success" && scope.row.status != "exception" &&scope.row.status != "warning"'><el-progress :text-inside="true" :stroke-width="24" :percentage="scope.row.pre"></el-progress></div>-->
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          width="90">
        <template slot-scope="scope">
          <el-button
              type="text"
              size="small"
              @click = "detailShow(scope.row)">
            详情
          </el-button>
          <el-button
              type="text"
              size="small"
              :loading="rukuSubmitting && rukuCheckId === scope.row.id"
              :disabled="rukuSubmitting"
              v-if='scope.row.status == "success" || scope.row.status == "unfinishedSuccess"'
              @click = "rukuCheck(scope.row.id)">
            入库
          </el-button>
        </template>
      </el-table-column>
<!--      <el-table-column-->
<!--          prop="gongxuDoing"-->
<!--          label="所在工序"-->
<!--          width="200">-->
<!--      </el-table-column>-->
    </el-table>
    <div style="margin: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-sizes="[5, 10, 20]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <el-dialog title="加工人员" :visible.sync="jiagongrenformListshow">
      <el-table
          :data="jiagongrenformList">
        <el-table-column type="expand">
          <template slot-scope="propser">
            <el-table
                :data="propser.row.processFeiJianList">
              <el-table-column
                  label="废件标签"
                  prop="scrapLabels">
              </el-table-column>
              <el-table-column
                  label="废件数量"
                  prop="scrapNumbers">
              </el-table-column>
              <el-table-column
                  label="备注"
                  prop="scrapNotes">
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column
            label="加工人"
            prop="personName">
        </el-table-column>
        <el-table-column
            label="加工数量"
            prop="num">
        </el-table-column>
        <el-table-column
            label="废件数量"
            prop="nonum">
        </el-table-column>
      </el-table>
    </el-dialog>

<!--  侧边栏  -->
    <el-drawer
        title="详情信息"
        :visible.sync="drawer"
        size="70%">
      <div class="detail-drawer">
        <el-card class="detail-card">
          <div slot="header">基础信息</div>
          <el-descriptions :column="2" border>
<!--            <el-descriptions-item label="工件ID">{{formatValue(detailform.id)}}</el-descriptions-item>-->
<!--            <el-descriptions-item label="型号ID">{{formatValue(detailform.serialId)}}</el-descriptions-item>-->
            <el-descriptions-item label="型号">{{formatValue(detailform.xinghao)}}</el-descriptions-item>
            <el-descriptions-item label="图纸号">{{formatValue(detailform.tuzhihao)}}</el-descriptions-item>
            <el-descriptions-item label="厂商">{{formatValue(detailform.changjia)}}</el-descriptions-item>
            <el-descriptions-item label="外协">{{formatBoolean(detailform.isWaiXie)}}</el-descriptions-item>
            <el-descriptions-item label="工件数量">{{formatValue(detailform.totalNum)}}</el-descriptions-item>
            <el-descriptions-item label="成品数">{{formatValue(detailform.chengpinNum)}}</el-descriptions-item>
<!--            <el-descriptions-item label="完成状态">{{formatFinish(detailform.finish)}}</el-descriptions-item>-->
<!--            <el-descriptions-item label="删除标识">{{formatValue(detailform.deleteFlag)}}</el-descriptions-item>-->
          </el-descriptions>
        </el-card>

        <el-card class="detail-card">
          <div slot="header">订单与时间</div>
          <el-descriptions :column="2" border>
<!--            <el-descriptions-item label="金蝶任务订单行ID">{{formatValue(detailform.jdOrderLineId)}}</el-descriptions-item>-->
<!--            <el-descriptions-item label="金蝶任务订单ID">{{formatValue(detailform.jdOrderId)}}</el-descriptions-item>-->
            <el-descriptions-item label="金蝶任务订单号">{{formatValue(detailform.jdOrderCode)}}</el-descriptions-item>
            <el-descriptions-item label="入厂时间">{{formatValue(detailform.intime)}}</el-descriptions-item>
            <el-descriptions-item label="发货时间">{{formatValue(detailform.sendtime)}}</el-descriptions-item>
            <el-descriptions-item label="出厂时间">{{formatValue(detailform.outtime)}}</el-descriptions-item>
<!--            <el-descriptions-item label="创建时间">{{formatValue(detailform.createTime)}}</el-descriptions-item>-->
<!--            <el-descriptions-item label="创建人">{{formatValue(detailform.createUser)}}</el-descriptions-item>-->
<!--            <el-descriptions-item label="更新时间">{{formatValue(detailform.updateTime)}}</el-descriptions-item>-->
<!--            <el-descriptions-item label="更新人">{{formatValue(detailform.updateUser)}}</el-descriptions-item>-->
          </el-descriptions>
        </el-card>

        <el-card class="detail-card">
          <div slot="header">进度汇总</div>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="总状态">{{formatStatus(detailform.status, detailform.zhuangtai)}}</el-descriptions-item>
            <el-descriptions-item label="所在工序">{{formatValue(detailform.gongxuDoing)}}</el-descriptions-item>
            <el-descriptions-item label="完成率">{{formatPercentText(detailform.pre)}}</el-descriptions-item>
            <el-descriptions-item label="工序数量">{{detailform.gongxuList ? detailform.gongxuList.length : 0}}</el-descriptions-item>
            <el-descriptions-item label="废件数">{{formatValue(detailform.feijainNum)}}</el-descriptions-item>
            <el-descriptions-item label="自废数">{{formatValue(detailform.zifeiNum)}}</el-descriptions-item>
            <el-descriptions-item label="废品率">{{formatPercentText(detailform.feijianPre)}}</el-descriptions-item>
            <el-descriptions-item label="自废率">{{formatPercentText(detailform.zifeiPre)}}</el-descriptions-item>
          </el-descriptions>
          <div class="progress-summary">
            <div class="progress-dashboard">
              <div class="progress-title">废品率</div>
              <el-progress type="dashboard" :percentage="formatPercentage(detailform.feijianPre)" :color="colors"></el-progress>
            </div>
            <div class="progress-dashboard">
              <div class="progress-title">自废率</div>
              <el-progress type="dashboard" :percentage="formatPercentage(detailform.zifeiPre)" :color="colors"></el-progress>
            </div>
          </div>
        </el-card>

        <el-card class="detail-card" v-if="detailform.gongxuList && detailform.gongxuList.length">
          <div slot="header">工序详情</div>
          <el-collapse accordion>
            <el-collapse-item
                v-for="(item, index) in detailform.gongxuList"
                :key="index"
                :name="index">
              <template slot="title">
                <div class="process-title">
                  <span class="process-name">{{formatValue(item.gongxu)}}</span>
                  <el-tag size="mini" :type="getStatusTagType(item.status)">
                    {{formatStatus(item.status, item.zhuangtai)}}
                  </el-tag>
                  <span class="process-rate">{{formatPercentText(item.pre)}}</span>
                </div>
              </template>

              <el-descriptions :column="2" border>
                <el-descriptions-item label="工序名称">{{formatValue(item.gongxu)}}</el-descriptions-item>
                <el-descriptions-item label="是否主工序">{{formatValue(item.isMain)}}</el-descriptions-item>
                <el-descriptions-item label="目标加工数">{{formatValue(item.mubiaoNum)}}</el-descriptions-item>
                <el-descriptions-item label="已加工数">{{formatValue(item.workedNum)}}</el-descriptions-item>
                <el-descriptions-item label="废件数">{{formatValue(item.feijianNum)}}</el-descriptions-item>
                <el-descriptions-item label="废品率">{{formatPercentText(item.feijianPre)}}</el-descriptions-item>
                <el-descriptions-item label="完成率">{{formatPercentText(item.pre)}}</el-descriptions-item>
                <el-descriptions-item label="状态">{{formatStatus(item.status, item.zhuangtai)}}</el-descriptions-item>
                <el-descriptions-item label="加工人">{{formatValue(item.renyuanList)}}</el-descriptions-item>
                <el-descriptions-item label="预计完工日期">
                  {{formatValue(item.finishDate)}}
                  <el-button type="text" size="mini" @click.stop="datedialog = true,finishDate = item.finishDate,finishGongjina = detailform.id,finishGongxu = item.gongxu">编辑</el-button>
                </el-descriptions-item>
              </el-descriptions>

              <div class="process-progress">
                <el-progress :percentage="formatPercentage(item.pre)" :status="getProgressStatus(item.status)"></el-progress>
              </div>

              <div class="detail-subtitle">废件汇总</div>
              <el-table
                  v-if="item.feijianxinxi && item.feijianxinxi.length"
                  :data="item.feijianxinxi"
                  border
                  size="mini"
                  class="detail-table">
                <el-table-column prop="scrapLabels" label="废件标签"></el-table-column>
                <el-table-column prop="num" label="数量" width="100"></el-table-column>
              </el-table>
              <div v-else class="detail-empty">暂无废件汇总</div>

              <div class="detail-subtitle">废件明细</div>
              <el-table
                  v-if="item.feiJianList && item.feiJianList.length"
                  :data="item.feiJianList"
                  border
                  size="mini"
                  class="detail-table">
                <el-table-column prop="scrapLabels" label="废件标签"></el-table-column>
                <el-table-column prop="scrapNumbers" label="废件数" width="100"></el-table-column>
                <el-table-column prop="yuangongName" label="人员" width="120"></el-table-column>
                <el-table-column prop="scrapNotes" label="备注"></el-table-column>
              </el-table>
              <div v-else class="detail-empty">暂无废件明细</div>

              <div class="detail-subtitle">加工人员明细</div>
              <el-table
                  v-if="item.renyuanxinxi && item.renyuanxinxi.length"
                  :data="item.renyuanxinxi"
                  border
                  size="mini"
                  class="detail-table">
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-table
                        v-if="props.row.processFeiJianList && props.row.processFeiJianList.length"
                        :data="props.row.processFeiJianList"
                        border
                        size="mini">
                      <el-table-column prop="scrapLabels" label="废件标签"></el-table-column>
                      <el-table-column prop="scrapNumbers" label="废件数量" width="100"></el-table-column>
                      <el-table-column prop="scrapNotes" label="备注"></el-table-column>
                    </el-table>
                    <div v-else class="detail-empty">暂无人员废件明细</div>
                  </template>
                </el-table-column>
                <el-table-column prop="personName" label="加工人"></el-table-column>
                <el-table-column prop="num" label="加工数量" width="100"></el-table-column>
                <el-table-column prop="nonum" label="废件数量" width="100"></el-table-column>
              </el-table>
              <div v-else class="detail-empty">暂无加工人员明细</div>
            </el-collapse-item>
          </el-collapse>
        </el-card>

        <el-card class="detail-card" v-if="detailOtherFields.length">
          <div slot="header">其他字段</div>
          <el-table :data="detailOtherFields" border size="mini">
            <el-table-column prop="label" label="字段" width="180"></el-table-column>
            <el-table-column prop="value" label="值"></el-table-column>
          </el-table>
        </el-card>
      </div>
    </el-drawer>
    <el-dialog
        title="设置最后日期"
        :visible.sync="datedialog"
        width="30%">
      <el-date-picker
        v-model="finishDate"
        type="date"
        placeholder="选择日期">
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateFinishDate()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="废件详情"
        :visible.sync="errorShow"
        width="30%">
      <error-products :id="errorId" v-if="errorShow"/>
    </el-dialog>
    <div v-show="rukuCheckSize !== 0">
      <el-dialog
          title="废件处理"
          :visible.sync="rukuCheckType"
          :before-close="handleClose"
          width="80%">
        <nonConformingProducts v-if="rukuCheckType" :searchId="rukuCheckId" @errorList="errorListSizeCheck"/>
      </el-dialog>
    </div>

  </div>
</template>

<script>

import request from "@/utils/request";
import progressBarGropu from "./element/progress_bar_group"
import errorProducts from "@/views/element/error_products_list";
import nonConformingProducts from "@/views/NonConformingProducts.vue";

export default {
  components: { progressBarGropu , errorProducts , nonConformingProducts},
  data() {
    return {
      drawer: false,
      search:'',
      currentPage4:1,
      size: 10,
      total:10,
      tableData: [],
      tableDataShow: [],
      sortDialogVisible: false,
      sortRules: [
        {prop: "sendtime", order: "descending"}
      ],
      sortOptions: [
        {label: "工件型号", prop: "xinghao", type: "string"},
        {label: "图纸号", prop: "tuzhihao", type: "string"},
        {label: "厂商", prop: "changjia", type: "string"},
        {label: "工件数量", prop: "totalNum", type: "number"},
        {label: "入厂时间", prop: "intime", type: "date"},
        {label: "发货时间", prop: "sendtime", type: "date"},
        {label: "废件数", prop: "feijainNum", type: "number"}
      ],
      detailform:{},
      jiagongrenformListshow: false,
      jiagongrenformList:[],
      colors: [
        {color: '#f56c6c', percentage: 20},
        {color: '#e6be3c', percentage: 40},
        {color: '#cdff4e', percentage: 60},
        {color: '#5cb87a', percentage: 80},
      ],
      datedialog: false,
      finishDate: null,
      finishGongjina: null,
      finishGongxu: null,
      upLode:true,
      errorId:0,
      errorShow:false,

      //入库校验
      rukuCheckType:false,
      rukuCheckId:0,
      rukuCheckSize:0,
      rukuSubmitting:false,
    }
  },
  computed: {
    detailOtherFields() {
      const shownFields = new Set([
        "id",
        "serialId",
        "xinghao",
        "tuzhihao",
        "changjia",
        "isWaiXie",
        "totalNum",
        "chengpinNum",
        "finish",
        "deleteFlag",
        "jdOrderLineId",
        "jdOrderId",
        "jdOrderCode",
        "intime",
        "sendtime",
        "outtime",
        "createTime",
        "createUser",
        "updateTime",
        "updateUser",
        "status",
        "zhuangtai",
        "gongxuDoing",
        "pre",
        "gongxuList",
        "feijainNum",
        "zifeiNum",
        "feijianPre",
        "zifeiPre"
      ]);
      return Object.keys(this.detailform || {})
          .filter(key => !shownFields.has(key))
          .map(key => ({
            label: key,
            value: this.formatOtherValue(this.detailform[key])
          }));
    }
  },
  filters:{
    ellipsis(value){
      if (!value) return '';
      if (value.length > 7) {
        return value.slice(0,6) + '...'
      }
      return value
    }
  },
  //加载表格
  mounted() {
    this.select()
  },
  methods:{
    formatValue(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      return value;
    },
    formatOtherValue(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      if (typeof value === "object") {
        return JSON.stringify(value);
      }
      return value;
    },
    formatBoolean(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      return value ? "是" : "否";
    },
    formatFinish(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      return Number(value) === 1 ? "已入库" : "加工中";
    },
    formatStatus(status, zhuangtai) {
      if (zhuangtai) {
        return zhuangtai;
      }
      const statusMap = {
        success: "已完成",
        unfinishedSuccess: "可入库",
        unFinish: "未完成",
        exception: "异常",
        warning: "有废件",
        doing: "进行中"
      };
      return statusMap[status] || this.formatValue(status);
    },
    formatPercentage(value) {
      const percentage = Number(value);
      if (Number.isNaN(percentage)) {
        return 0;
      }
      return Math.max(0, Math.min(100, percentage));
    },
    formatPercentText(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      return `${value}%`;
    },
    getStatusTagType(status) {
      if (status === "success" || status === "unfinishedSuccess") {
        return "success";
      }
      if (status === "exception") {
        return "danger";
      }
      if (status === "warning") {
        return "warning";
      }
      return "info";
    },
    getProgressStatus(status) {
      if (status === "success") {
        return "success";
      }
      if (status === "exception") {
        return "exception";
      }
      if (status === "warning") {
        return "warning";
      }
      return undefined;
    },
    getFinishDate(gongjian,gongxu){
      let item = {
        gongjian:gongjian,
        gongxu:gongxu
      }
      request.post("/getFinishDate",item).then(res => {
        if (res.code === '200') {
          // console.log("finishDate",res.data.finishDate)
          // return res.data.finishDate;
          return "2007-04-22"
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {
        return null;
      });
    },
    updateFinishDate(gongjian,gongxu){
      this.datedialog = false;
      let item = {
        gongjian:this.finishGongjina,
        gongxu:this.finishGongxu,
        finishDate:this.finishDate,
      }
      request.post("/updateFinishDate",item).then(res => {
        if (res.code === '200') {
          this.select();
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {
        return null;
      });
    },
    clean(){
      this.$confirm('确定要清除缓存并刷新吗？这可能需要一些时间', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.post("/ProgressClean").then(res => {
          if (res.code === '200') {
            this.select()
          } else {
            this.$message.error(res.msg)
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消刷新'
        });
      });
    },
    //整表查询
    renyuanshow(formList){
      this.jiagongrenformListshow = true
      this.jiagongrenformList = formList;
    },
    select() {
      this.tableData = [];
      this.tableDataShow = [];
      request.post("/Progress").then(res => {
        if (res.code === '200') {
          this.tableData = res.data
          this.detailform = this.tableData[0]
          this.total = res.data.length;
          this.getTableDataShow();
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    rukuCheck(id){
      if (this.rukuSubmitting) {
        return;
      }
      this.rukuCheckSize = 0;
      this.rukuCheckType = true;
      this.rukuCheckId = id;
    },
    errorListSizeCheck(msg){
      this.rukuCheckSize = msg
      if (msg === 0 && this.rukuCheckId > 0 && !this.rukuSubmitting){
        this.rukuCheckType = false;
        this.ruku(this.rukuCheckId)
      }
    },
    //整表查询
    ruku(id) {
      if (!id || this.rukuSubmitting) {
        return;
      }
      this.rukuSubmitting = true;
      request.post("/Ruku" ,id).then(res => {
        if (res.code === '200') {
          this.select();
          const message = res.msg || res.data || "";
          if (message.includes("[ERROR:]")){
            this.$message.error("入库单自动创建失败，请手动创建入库单")
          } else if (message.includes("已入库")) {
            this.$message.success(message)
          } else {
            this.$message.success("入库成功")
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {
        this.$message.error("入库失败")
      }).finally(() => {
        this.rukuSubmitting = false;
        this.rukuCheckId = 0;
      })
    },
    //详情展示
    detailShow(row) {
      this.detailform = row;
      this.drawer = true;
    },
    //详情展示
    getPercent(fenzi,fenmu) {
      let num = (fenzi*100)/fenmu
      return alert(num.toFixed(2))
    },
    //重置
    remove(){
      this.search=''
      this.getTableDataShow();
    },
    handleSizeChange(val) {
      this.upLode = false;
      this.size = val;
      this.getTableDataShow();
      this.$nextTick(()=>{
        this.upLode = true;
      })
      //console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.upLode = false;
      this.currentPage4 = val;
      this.getTableDataShow();
      this.$nextTick(()=>{
        this.upLode = true;
      })
    },
    handleSortChange({prop, order}) {
      if (!prop) {
        return;
      }
      if (!order) {
        this.sortRules = this.sortRules.filter(rule => rule.prop !== prop);
      } else {
        this.sortRules = [{prop, order}];
      }
      this.getTableDataShow();
    },
    addSortRule() {
      const option = this.sortOptions.find(item => !this.sortRules.some(rule => rule.prop === item.prop));
      if (!option) {
        this.$message.info("已添加全部可排序字段");
        return;
      }
      this.sortRules.push({
        prop: option.prop,
        order: "ascending"
      });
      this.getTableDataShow();
    },
    removeSortRule(index) {
      this.sortRules.splice(index, 1);
      this.getTableDataShow();
    },
    moveSortRule(index, step) {
      const targetIndex = index + step;
      if (targetIndex < 0 || targetIndex >= this.sortRules.length) {
        return;
      }
      const rule = this.sortRules.splice(index, 1)[0];
      this.sortRules.splice(targetIndex, 0, rule);
      this.getTableDataShow();
    },
    clearSortRules() {
      this.sortRules = [];
      this.getTableDataShow();
    },
    getSortOption(prop) {
      return this.sortOptions.find(option => option.prop === prop) || {};
    },
    isSortOptionDisabled(prop, currentIndex) {
      return this.sortRules.some((rule, index) => index !== currentIndex && rule.prop === prop);
    },
    getSortValue(row, prop) {
      return prop.split(".").reduce((value, key) => {
        if (value === null || value === undefined) {
          return undefined;
        }
        return value[key];
      }, row);
    },
    compareSortValue(left, right, type) {
      const leftEmpty = left === null || left === undefined || left === "";
      const rightEmpty = right === null || right === undefined || right === "";
      if (leftEmpty && rightEmpty) {
        return 0;
      }
      if (leftEmpty) {
        return 1;
      }
      if (rightEmpty) {
        return -1;
      }
      if (type === "number") {
        const leftNumber = Number(left);
        const rightNumber = Number(right);
        if (!Number.isNaN(leftNumber) && !Number.isNaN(rightNumber)) {
          return leftNumber - rightNumber;
        }
      }
      if (type === "date") {
        const leftTime = Date.parse(left);
        const rightTime = Date.parse(right);
        if (!Number.isNaN(leftTime) && !Number.isNaN(rightTime)) {
          return leftTime - rightTime;
        }
      }
      return String(left).localeCompare(String(right), "zh-CN", {
        numeric: true,
        sensitivity: "base"
      });
    },
    applySortRules(list) {
      if (this.sortRules.length === 0) {
        return list;
      }
      return list.concat().sort((leftRow, rightRow) => {
        for (let i = 0; i < this.sortRules.length; i++) {
          const rule = this.sortRules[i];
          const option = this.getSortOption(rule.prop);
          const leftValue = this.getSortValue(leftRow, rule.prop);
          const rightValue = this.getSortValue(rightRow, rule.prop);
          const leftEmpty = leftValue === null || leftValue === undefined || leftValue === "";
          const rightEmpty = rightValue === null || rightValue === undefined || rightValue === "";
          if (leftEmpty || rightEmpty) {
            if (leftEmpty && rightEmpty) {
              continue;
            }
            return leftEmpty ? 1 : -1;
          }
          const result = this.compareSortValue(leftValue, rightValue, option.type);
          if (result !== 0) {
            return rule.order === "descending" ? -result : result;
          }
        }
        return 0;
      });
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            this.rukuCheckSize = 0
            done();
          })
          .catch(_ => {
          });
    },
    async getTableDataShow(){
      let _tableData = (this.search === undefined || this.search === null || this.search === "") ? this.tableData : this.tableData.concat().filter(item => {
        //型号匹配
        try{
          if (item.xinghao.toLowerCase().toString().includes(this.search.toLowerCase().toString())){
            return true
          }
        }catch (e) {}
        //图纸号匹配
        try{
          if (item.tuzhihao.toLowerCase().toString().includes(this.search.toLowerCase().toString())){
            return true
          }
        }catch (e) {}
        //厂商匹配
        try{
          if (item.changjia.toLowerCase().toString().includes(this.search.toLowerCase().toString())){
            return true
          }
        }catch (e) {}
        //总数匹配
        try{
          if ( item.totalNum.toString() === this.search.toString()){
            return true
          }
        }catch (e) {}
        //包含工序匹配
        // try{
        //   if (item.gongxuList.indexOf(ch => {
        //     console.log(ch)
        //     return ch.gongxu.toString().includes(this.search)
        //   }) != -1){
        //     return true
        //   }
        // }catch (e) {}
        return false
      })
      _tableData = this.applySortRules(_tableData)
      let _pageMax = Math.ceil(_tableData.length/this.size)
      this.currentPage4 = this.currentPage4>_pageMax ? _pageMax :this.currentPage4;
      this.currentPage4 = this.currentPage4 < 1 ? 1 : this.currentPage4

      this.tableDataShow = _tableData.slice((this.currentPage4-1)*this.size,this.currentPage4*this.size);

      this.$nextTick(() => {
        this.total = _tableData.length
        // this.formLoading = false;
      })
    },
    onSubmit() {
      console.log('submit!');
    }
  }
}

</script>

<style scoped>
.text {
  font-size: 14px;
}

.item {
  padding: 18px 0;
}

.box-card {
  width: 440px;
}

.box-card2 {
  width: 390px;
}

.sort-rule-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.sort-empty {
  color: #909399;
  line-height: 32px;
}

.detail-drawer {
  padding: 10px 16px 24px;
}

.detail-card {
  margin-bottom: 12px;
}

.progress-summary {
  display: flex;
  gap: 24px;
  padding-top: 16px;
}

.progress-dashboard {
  text-align: center;
}

.progress-title {
  color: #606266;
  font-size: 13px;
  margin-bottom: 8px;
}

.process-title {
  align-items: center;
  display: flex;
  gap: 10px;
  min-width: 0;
  width: 100%;
}

.process-name {
  color: #303133;
  flex: 1;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.process-rate {
  color: #606266;
  font-size: 13px;
  width: 52px;
}

.process-progress {
  margin: 14px 0;
}

.detail-subtitle {
  color: #303133;
  font-weight: 500;
  margin: 16px 0 8px;
}

.detail-table {
  margin-bottom: 8px;
}

.detail-empty {
  color: #909399;
  font-size: 13px;
  line-height: 28px;
}
</style>
